module.exports = __webpack_public_path__ + "static/media/users.d47e2183.svg";